<template minapp='mpx' xlang='wxml'>
  <from-item isShow="{{isShow}}" 
    isRequired="{{isRequired}}" 
    isRequiredShow="{{isRequiredShow}}" 
    label="乘客类型" 
    innerValue="{{showValue}}"
    isDisable="{{isPassengerTypeDisable}}"
  >
    <view class="es-content__type" slot="input">
      <view wx:for="{{typeList}}" class="type-item {{innerValue === item.value ? 'selected' : ''}}" bindtap="selectType(item.value)">
        <text class="type-text">{{item.label}}</text>
        <view wx:if="{{innerValue === item.value}}" class="type-item-selected-icon">
          <es-icon size="6" name="check" color="#fff"/>
        </view>
      </view>
    </view>
  </from-item>
</template>

<script>
import { watch } from "@mpxjs/core";
  import { hasRequired } from '@/utils'
  import { createComponent } from '@didi/es-mpx-creator'
  createComponent({
    classes: [],
    data: {
      showValue: '',
      innerValue: 0,
      typeList: [
        {
          label: '成人',
          value: 0
        },
        {
          label: '学生',
          value: 2
        },
        {
          label: '儿童',
          value: 1
        }
      ]
    },
    props: {
      item: {
        type: Object,
        value: () => {}
      },
      value:{
        type: Number,
        value: 0
      },
      isRequiredShow: {
        type: Boolean,
        value: false
      },
      isPassengerTypeDisable: {
        type: Boolean,
        value: false
      },
      isShow: {
        type: Boolean,
        value: false
      },
    },
    computed: {
      isRequired() {
        return hasRequired(this.item?.requiredcCrdTypes,this.selectedCardList,this.item?.isRequired,this.isNeedCard)
      }
    },
    methods: {
      // 选择性别
      selectType(e) {
        this.innerValue = e || 0
      },
      updateShowValue(key = 0) {
        return +key === 0 ? '成人' : +key === 1 ? '儿童' : '学生'
      }
    },
    watch:{
      value(val) {
        this.innerValue = val
      },
      //将数据回传
      innerValue(newValue) {
        this.showValue = this.updateShowValue(newValue)
        this.$trigger( 'input', {value:newValue} )
      },
    },
    mounted() {
      this.showValue = this.updateShowValue(this.value)
      this.innerValue = this.value
    }
  })
</script>

<style lang='stylus' scoped>
  +b('content')
    +e('type')
      display flex
      align-items center
      color #333333
      .type-item
        display flex
        align-items center
        justify-content: center;
        width 60px
        height 24px
        margin-right 12px
        padding 8px
        border-radius 4px
        background #F6F8FA
        position relative
        box-sizing border-box
        &.selected
          background #EDF4FF
          border 0.5px solid #438FFF
          color #1473FF
        &-selected-icon
          width 12px
          height 8px
          border-radius 4px 0px 4px 0px
          background #1473FF
          display flex
          align-items center
          justify-content center
          position absolute
          right 0
          bottom 0
      .type-text
        font-size 12px
        // margin-left 8px
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'radio-circle': '../../radio-circle',
      'from-item': './from-item',
      'es-icon': '@didi/es-mpx-ui/lib/icon',
    }
  }
</script>

